<template>
    <drag
        :data="dragData"
        :type="dragType"
        @dragend = "onDragend"
        @cut     = "onCut"
        :key="dragData ? dragData.id : 0"
    >
        <v-card
            flat
            rounded
            :ripple = "false"
            :class  = "background"
            @click  = "onSelect"
            @contextmenu="onContext"
        >
            <div
                :class ="borderWidth + (border ? ' lm-border' : '')"
                :style = "'height: ' + height + 'px'"
            >
                <!--  Title-->
                <div class="v-flex w-100" :style="'height: ' + titleHeight + 'px'">
                    <div class="mr-1" v-if="icon.label">
                        <v-menu
                            open-on-hover
                            bottom
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <b
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <c-tag
                                        :label            = "icon.label"
                                        :active           = "icon.active"
                                        :background-color = "highlightColor"
                                    />
                                </b>
                            </template>

                            <slot name="tag" />
                        </v-menu>
                    </div>
                    <div
                        class="card-title v-flex"
                        :class="highlightColor + '--text'"
                        :style="titleStyle">
                        <slot name="title" />
                    </div>

                    <v-spacer />

                    <slot name="toolbar" />
                    <a @click.stop="onEdit" v-if="edit">
                        <v-icon
                            :color = "highlightColor"
                            size  = "20"
                            style = "margin-top: -2px"
                            class = "toolbar-button"
                        >
                            mdi-pencil
                        </v-icon>
                    </a>
                    <slot name="buttons" />
                </div>
                <!--  Title-->

                <!-- Subtitle -->
                <div
                    class  = "card-subtitle"
                    style  = "margin-top: -1px"
                >
                    <slot name="subtitle" />
                </div>
                <!-- Subtitle -->

                <div class="card-body">
                    <slot name="body" />
                </div>

                <div class="card-footer">
                    <slot name="footer" />
                </div>
            </div>
        </v-card>
    </drag>
</template>

<script>
import CTag from "@/modules/core/components/utils/CTag";
import {Drag} from "vue-easy-dnd"
import Core from "@/modules/core/service/Core";
export default {
    name: "CListCard",
    components: {
        CTag,
        Drag
    },

    props: {
        icon: {
            required: false,
            type    : Object,
            default : function () {
                return {
                    label : null,
                    active: false
                };
            }
        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        edit: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        border: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        titleHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 22;
            }
        },

        height: {
            required: false,
            type    : Number,
            default : function () {
                return 190;
            }
        },

        highlightColor: {
            required: false,
            type    : String,
            default : function () {
                return "primary";
            }
        },

        dragType: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        dragData: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        },

        borderWidth: {
            required: false,
            type    : String,
            default : function () {
                return "pa-3";
            }
        },
    },

    data: () => ({

    }),

    watch: {
        dragData: {
            deep: true,
            handler: function () {
            }
        },
    },

    mounted() {
    },

    computed: {
        titleStyle () {
            const cut = 60;
            return this.icon.label ? "max-width: calc(100% - " + cut + "px); width: calc(100% - " + cut + "px);" : "width: 100%";
        }
    },

    methods: {
        onSelect () {
            this.$emit("selected");
        },

        onEdit (event) {
            event.stopPropagation();
            this.$emit("edit");
        },

        onContext (event) {
            this.$emit("context", event)
        },

        onCut () {

        },

        onDragend (event) {
            this.$emit("dragend", event);
        },

        toHtml (text) {
            return Core.format.html(text);
        }
    }
}
</script>

<style scoped>

.card-title {
    font-size: 15px;
}

.card-body {
    font-size: 15px;
}

.card-subtitle {
    max-width: 100%;
    font-size: 11px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.card-footer {
    font-size: 11px;
    height: 20px;
    width: calc(100% - 15px);
  /*  position: absolute; */
    bottom: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

::v-deep .v-card--link:focus:before {
    opacity: 0.0!important;
}

</style>
